// Registro de tipos de nó do Flow Builder — espelha o projeto original (React Flow),
// agora em Vue. Cada nó: type, label, description, color (chave da paleta), icon (paths SVG),
// whatsappOnly. As seções colapsáveis reproduzem a NodesSidebar original.

// Paleta: accent (ícone/handle/borda selecionada), border (borda padrão), bg (fundo do card).
export const COLORS = {
  blue: { accent: '#2563eb', border: '#93c5fd', bg: '#eff6ff' },
  purple: { accent: '#7c3aed', border: '#d8b4fe', bg: '#faf5ff' },
  teal: { accent: '#0d9488', border: '#5eead4', bg: '#f0fdfa' },
  indigo: { accent: '#4f46e5', border: '#a5b4fc', bg: '#eef2ff' },
  green: { accent: '#16a34a', border: '#86efac', bg: '#f0fdf4' },
  cyan: { accent: '#0891b2', border: '#67e8f9', bg: '#ecfeff' },
  yellow: { accent: '#ca8a04', border: '#fde047', bg: '#fefce8' },
  orange: { accent: '#ea580c', border: '#fdba74', bg: '#fff7ed' },
  pink: { accent: '#db2777', border: '#f9a8d4', bg: '#fdf2f8' },
  violet: { accent: '#7c3aed', border: '#c4b5fd', bg: '#f5f3ff' },
  amber: { accent: '#d97706', border: '#fcd34d', bg: '#fffbeb' },
  red: { accent: '#dc2626', border: '#fca5a5', bg: '#fef2f2' },
  emerald: { accent: '#059669', border: '#6ee7b7', bg: '#ecfdf5' },
};

// d() = paths outline (stroke). Alguns nós têm 2 paths.
const I = {
  chat: [
    'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
  ],
  image: [
    'M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z',
  ],
  video: [
    'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
  ],
  audio: [
    'M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3',
  ],
  file: [
    'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  ],
  list: ['M4 6h16M4 10h16M4 14h8'],
  question: [
    'M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  ],
  switch: ['M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4'],
  clock: ['M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'],
  check: ['M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'],
  tag: [
    'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z',
  ],
  user: ['M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'],
  columns: [
    'M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2',
  ],
  pencil: [
    'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
  ],
  variable: ['M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4'],
  ai: [
    'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
  ],
  book: [
    'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
  ],
  calendarCheck: [
    'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
  ],
  calendar: [
    'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  ],
  calendarX: [
    'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
    'M10 14l4 4m0-4l-4 4',
  ],
  share: [
    'M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z',
  ],
  play: [
    'M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z',
    'M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  ],
  stop: [
    'M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    'M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z',
  ],
  whatsapp: [
    'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z',
  ],
  clipboard: [
    'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
  ],
};

// Lista plana — usada pelo canvas (lookup por type) e pelo painel de config.
// label/desc são CHAVES i18n (namespace CHATBOT); os componentes que renderizam chamam t(meta.label).
// Mapa de tipo de nó → chave i18n em CHATBOT.nodes.* (alguns nomes diferem do type).
const NODE_I18N_KEY = {
  start: 'startTrigger',
  generateImage: 'imageGeneration',
};
const nodeI18nKey = type => NODE_I18N_KEY[type] || type;
const lbl = type => `CHATBOT.nodes.${nodeI18nKey(type)}.label`;
const dsc = type => `CHATBOT.nodes.${nodeI18nKey(type)}.desc`;

export const NODE_DEFS = {
  sendText: {
    label: lbl('sendText'),
    desc: dsc('sendText'),
    color: 'blue',
    icon: I.chat,
    preview: d => d.message || d.text,
  },
  sendImage: {
    label: lbl('sendImage'),
    desc: dsc('sendImage'),
    color: 'purple',
    icon: I.image,
    preview: (d, t) =>
      d.caption || (d.imageUrl ? t('CHATBOT.nodes.sendImage.attached') : ''),
  },
  sendVideo: {
    label: lbl('sendVideo'),
    desc: dsc('sendVideo'),
    color: 'purple',
    icon: I.video,
    preview: (d, t) =>
      d.caption || (d.videoUrl ? t('CHATBOT.nodes.sendVideo.attached') : ''),
  },
  sendAudio: {
    label: lbl('sendAudio'),
    desc: dsc('sendAudio'),
    color: 'teal',
    icon: I.audio,
    preview: (d, t) =>
      d.audioUrl ? t('CHATBOT.nodes.sendAudio.attached') : '',
  },
  sendFile: {
    label: lbl('sendFile'),
    desc: dsc('sendFile'),
    color: 'indigo',
    icon: I.file,
    preview: d => d.fileName || d.caption,
  },
  sendWATemplate: {
    label: lbl('sendWATemplate'),
    desc: dsc('sendWATemplate'),
    color: 'green',
    icon: I.whatsapp,
    fill: true,
    whatsappOnly: true,
    preview: d => d.templateName,
  },
  sendWAInteractive: {
    label: lbl('sendWAInteractive'),
    desc: dsc('sendWAInteractive'),
    color: 'cyan',
    icon: I.list,
    whatsappOnly: true,
    preview: d => d.bodyText,
  },
  condition: {
    label: lbl('condition'),
    desc: dsc('condition'),
    color: 'yellow',
    icon: I.question,
    preview: d =>
      d.conditionType === 'advanced'
        ? d.condition
        : `${d.field || ''} ${d.operator || ''} ${d.value || ''}`.trim(),
  },
  switch: {
    label: lbl('switch'),
    desc: dsc('switch'),
    color: 'indigo',
    icon: I.switch,
    preview: d =>
      (d.cases || [])
        .map(c => c.label)
        .filter(Boolean)
        .join(', '),
  },
  delay: {
    label: lbl('delay'),
    desc: dsc('delay'),
    color: 'orange',
    icon: I.clock,
    preview: d =>
      d.delayType === 'range'
        ? d.minSeconds && `${d.minSeconds}-${d.maxSeconds}s`
        : d.seconds && `${d.seconds}s`,
  },
  sequenceDelay: {
    label: lbl('sequenceDelay'),
    desc: dsc('sequenceDelay'),
    color: 'purple',
    icon: I.clock,
    preview: d => d.value && `${d.value} ${d.unit || ''}`,
  },
  checkResponse: {
    label: lbl('checkResponse'),
    desc: dsc('checkResponse'),
    color: 'purple',
    icon: I.chat,
    preview: () => null,
  },
  changeStatus: {
    label: lbl('changeStatus'),
    desc: dsc('changeStatus'),
    color: 'indigo',
    icon: I.check,
    preview: d => d.status,
  },
  labels: {
    label: lbl('labels'),
    desc: dsc('labels'),
    color: 'pink',
    icon: I.tag,
    preview: d => `${d.action || 'add'}: ${(d.labels || [])[0] || ''}`,
  },
  assign: {
    label: lbl('assign'),
    desc: dsc('assign'),
    color: 'teal',
    icon: I.user,
    preview: (d, t) =>
      d.assignType === 'team'
        ? t('CHATBOT.nodes.assign.team')
        : t('CHATBOT.nodes.assign.agent'),
  },
  moveToStage: {
    label: lbl('moveToStage'),
    desc: dsc('moveToStage'),
    color: 'orange',
    icon: I.columns,
    preview: d =>
      d.mode === 'ai' ? `IA: {{${d.stageVariable || ''}}}` : d.stageId,
  },
  applySLA: {
    label: lbl('applySLA'),
    desc: dsc('applySLA'),
    color: 'amber',
    icon: I.clock,
    preview: d => d.slaId,
  },
  waitForResponse: {
    label: lbl('waitForResponse'),
    desc: dsc('waitForResponse'),
    color: 'cyan',
    icon: I.switch,
    preview: (d, t) =>
      d.timeout
        ? `timeout ${d.timeout}s`
        : t('CHATBOT.nodes.waitForResponse.noTimeout'),
  },
  input: {
    label: lbl('input'),
    desc: dsc('input'),
    color: 'purple',
    icon: I.pencil,
    preview: d => d.variableName && `{{${d.variableName}}}`,
  },
  setVariable: {
    label: lbl('setVariable'),
    desc: dsc('setVariable'),
    color: 'violet',
    icon: I.variable,
    preview: d => d.variableName && `${d.variableName} (${d.mode || 'custom'})`,
  },
  customAttribute: {
    label: lbl('customAttribute'),
    desc: dsc('customAttribute'),
    color: 'teal',
    icon: I.tag,
    preview: d => d.attributeKey && `${d.action || 'set'}: ${d.attributeKey}`,
  },
  aiAgent: {
    label: lbl('aiAgent'),
    desc: dsc('aiAgent'),
    color: 'purple',
    icon: I.ai,
    preview: d => d.model,
  },
  knowledgeBase: {
    label: lbl('knowledgeBase'),
    desc: dsc('knowledgeBase'),
    color: 'indigo',
    icon: I.book,
    preview: d => d.name,
  },
  generateImage: {
    label: lbl('generateImage'),
    desc: dsc('generateImage'),
    color: 'violet',
    icon: I.image,
    preview: d => d.prompt,
  },
  checkAvailability: {
    label: lbl('checkAvailability'),
    desc: dsc('checkAvailability'),
    color: 'cyan',
    icon: I.calendarCheck,
    preview: d => d.saveResultTo && `→ ${d.saveResultTo}`,
  },
  scheduleAppointment: {
    label: lbl('scheduleAppointment'),
    desc: dsc('scheduleAppointment'),
    color: 'teal',
    icon: I.calendar,
    preview: d => d.saveResultTo && `→ ${d.saveResultTo}`,
  },
  cancelAppointment: {
    label: lbl('cancelAppointment'),
    desc: dsc('cancelAppointment'),
    color: 'red',
    icon: I.calendarX,
    preview: d => d.appointmentIdVariable || d.appointmentIdFixed,
  },
  aiSchedulingAgent: {
    label: lbl('aiSchedulingAgent'),
    desc: dsc('aiSchedulingAgent'),
    color: 'emerald',
    icon: I.ai,
    preview: d => d.model,
  },
  httpRequest: {
    label: lbl('httpRequest'),
    desc: dsc('httpRequest'),
    color: 'cyan',
    icon: I.share,
    preview: d => d.url && `${d.method || 'POST'} ${d.url}`,
  },
  start: {
    label: lbl('start'),
    desc: dsc('start'),
    color: 'green',
    icon: I.play,
    preview: () => null,
  },
  end: {
    label: lbl('end'),
    desc: dsc('end'),
    color: 'red',
    icon: I.stop,
    preview: () => null,
  },
};

// Seções colapsáveis (ordem e conteúdo idênticos ao original). title é CHAVE i18n.
export const SECTIONS = [
  {
    id: 'send',
    title: 'CHATBOT.nodes.sidebar.sections.send',
    icon: I.chat,
    nodes: [
      'sendText',
      'sendImage',
      'sendVideo',
      'sendAudio',
      'sendFile',
      'sendWATemplate',
      'sendWAInteractive',
    ],
  },
  {
    id: 'conditions',
    title: 'CHATBOT.nodes.sidebar.sections.conditions',
    icon: I.question,
    nodes: ['condition', 'switch'],
  },
  {
    id: 'actions',
    title: 'CHATBOT.nodes.sidebar.sections.actions',
    icon: I.clock,
    nodes: [
      'delay',
      'sequenceDelay',
      'checkResponse',
      'changeStatus',
      'labels',
      'assign',
      'moveToStage',
      'applySLA',
      'waitForResponse',
      'input',
      'setVariable',
      'customAttribute',
    ],
  },
  {
    id: 'integrations',
    title: 'CHATBOT.nodes.sidebar.sections.integrations',
    icon: I.share,
    nodes: [
      'aiAgent',
      'knowledgeBase',
      'generateImage',
      'checkAvailability',
      'scheduleAppointment',
      'cancelAppointment',
      'aiSchedulingAgent',
      'httpRequest',
    ],
  },
  {
    id: 'startEnd',
    title: 'CHATBOT.nodes.sidebar.sections.startEnd',
    icon: I.play,
    nodes: ['start', 'end'],
  },
];

export const nodeMeta = type =>
  NODE_DEFS[type] || {
    label: type,
    desc: '',
    color: 'blue',
    icon: I.chat,
    preview: () => null,
  };
export const nodeColor = type => COLORS[nodeMeta(type).color] || COLORS.blue;
